export enum lastActivityState {
  BreakOrRest = "BreakOrRest",
  Available = "Available",
  Work = "Work",
  Drive = "Drive",
  Unknown4 = "Unknown4",
  Unknown5 = "Unknown5",
  NotAvailable = "NotAvailable"
}

export enum VEHICLE_ACTIVATION_STATUS {
  Activated = "Activated",
  Deactivated = "Deactivated"
}
